function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M352.464,212.006h-61.817c3.817-3.996,6.165-9.405,6.165-15.368c0-12.295-9.966-22.261-22.261-22.261  c-7.745,0-14.563,3.957-18.551,9.958c-3.988-6-10.805-9.958-18.551-9.958c-12.295,0-22.261,9.966-22.261,22.261  c0,5.963,2.349,11.372,6.165,15.368h-61.817c0,16.393,14.278,29.68,30.67,29.68h-0.988c0,16.393,13.289,29.682,29.682,29.682  c0,5.309,1.399,10.287,3.842,14.595l-24.619,24.621l18.888,18.888l26.794-26.794c1.05,0.385,2.136,0.692,3.257,0.903l-16.191,36.557  L256,367.304l25.13-27.167l-16.191-36.557c1.122-0.21,2.207-0.518,3.257-0.903l26.794,26.794l18.888-18.888l-24.621-24.621  c2.443-4.309,3.842-9.286,3.842-14.595c16.393,0,29.682-13.289,29.682-29.682h-0.988  C338.186,241.686,352.464,228.399,352.464,212.006z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg117Albania(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 512
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg117Albania);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxwYXRoIGQ9Ik0zNTIuNDY0LDIxMi4wMDZoLTYxLjgxN2MzLjgxNy0zLjk5Niw2LjE2NS05LjQwNSw2LjE2NS0xNS4zNjhjMC0xMi4yOTUtOS45NjYtMjIuMjYxLTIyLjI2MS0yMi4yNjEgIGMtNy43NDUsMC0xNC41NjMsMy45NTctMTguNTUxLDkuOTU4Yy0zLjk4OC02LTEwLjgwNS05Ljk1OC0xOC41NTEtOS45NThjLTEyLjI5NSwwLTIyLjI2MSw5Ljk2Ni0yMi4yNjEsMjIuMjYxICBjMCw1Ljk2MywyLjM0OSwxMS4zNzIsNi4xNjUsMTUuMzY4aC02MS44MTdjMCwxNi4zOTMsMTQuMjc4LDI5LjY4LDMwLjY3LDI5LjY4aC0wLjk4OGMwLDE2LjM5MywxMy4yODksMjkuNjgyLDI5LjY4MiwyOS42ODIgIGMwLDUuMzA5LDEuMzk5LDEwLjI4NywzLjg0MiwxNC41OTVsLTI0LjYxOSwyNC42MjFsMTguODg4LDE4Ljg4OGwyNi43OTQtMjYuNzk0YzEuMDUsMC4zODUsMi4xMzYsMC42OTIsMy4yNTcsMC45MDNsLTE2LjE5MSwzNi41NTcgIEwyNTYsMzY3LjMwNGwyNS4xMy0yNy4xNjdsLTE2LjE5MS0zNi41NTdjMS4xMjItMC4yMSwyLjIwNy0wLjUxOCwzLjI1Ny0wLjkwM2wyNi43OTQsMjYuNzk0bDE4Ljg4OC0xOC44ODhsLTI0LjYyMS0yNC42MjEgIGMyLjQ0My00LjMwOSwzLjg0Mi05LjI4NiwzLjg0Mi0xNC41OTVjMTYuMzkzLDAsMjkuNjgyLTEzLjI4OSwyOS42ODItMjkuNjgyaC0wLjk4OCAgQzMzOC4xODYsMjQxLjY4NiwzNTIuNDY0LDIyOC4zOTksMzUyLjQ2NCwyMTIuMDA2eiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };